import { render, staticRenderFns } from "./Thanks.vue?vue&type=template&id=0b542b6d&scoped=true"
import script from "./Thanks.vue?vue&type=script&lang=js"
export * from "./Thanks.vue?vue&type=script&lang=js"
import style0 from "./Thanks.vue?vue&type=style&index=0&id=0b542b6d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b542b6d",
  null
  
)

export default component.exports